var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6641 6.4239L21.4984 6.12807C21.2847 5.77033 20.9833 5.47301 20.6228 5.26423L12.6826 0.684734C12.3231 0.476172 11.915 0.365968 11.4993 0.365234H11.1561C10.7404 0.365968 10.3323 0.476172 9.97276 0.684734L2.03259 5.27607C1.67401 5.48346 1.37615 5.78131 1.16876 6.1399L1.00309 6.43573C0.794531 6.79528 0.684327 7.20341 0.683594 7.61907V16.7899C0.684327 17.2056 0.794531 17.6137 1.00309 17.9732L1.16876 18.2691C1.38151 18.6235 1.67817 18.9201 2.03259 19.1329L9.98459 23.7124C10.3423 23.9253 10.7516 24.0358 11.1679 24.0319H11.4993C11.915 24.0312 12.3231 23.921 12.6826 23.7124L20.6228 19.1211C20.9849 18.9184 21.2839 18.6193 21.4866 18.2572L21.6641 17.9614C21.8701 17.6008 21.9802 17.1934 21.9836 16.7781V7.60723C21.9829 7.19157 21.8727 6.78344 21.6641 6.4239ZM11.1561 2.7319H11.4993L18.4336 6.73157L11.3336 10.8259L4.23359 6.73157L11.1561 2.7319ZM12.5169 21.0736L19.4394 17.0739L19.6169 16.7781V8.77873L12.5169 12.8849V21.0736Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqBtn);
export default __webpack_public_path__ + "static/media/faqBtn.32a9aef372cde5df5ef67a8f3e7b39ab.svg";
export { ForwardRef as ReactComponent };